// AWS Amplify Configuration
export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID || 'us-east-1_mZTqwGEfo',
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '7ihcmtf0sdgd4r77hbvt2orr12',
      region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
    }
  }
};

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api-dev.theforagingfoodie.com';
